import React, { useContext } from 'react';
import { Row, Col } from 'reactstrap';

import Tasks from './Tasks';
import Organisers from './Organisers';
import { AuthContext } from '../../../../../Data/AuthContext';
import { MEMBER } from '../../../../../Data/Constants';

function MemberSection(props) {
    const auth = useContext(AuthContext);

    if (auth.roles && auth.roles.includes(MEMBER)) {
        return (
            <Row>
                <Col>
                    <h3>Rendezői részleg</h3>
                    <Organisers {...props} />
                    <Tasks {...props}/>
                </Col>
            </Row>
        );
    }

    return null;
}

export default MemberSection;